import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '../modal.service';
import { AppService } from 'src/app/server/app.service';
import { Subscription } from 'rxjs';
import { ModalConfig } from '../modal.model';

import { environment } from "../../../../environments/environment"
import { ViewComponent } from '../../view/view.component';
export let isDebugMode = environment.isDebugMode


@Component({
    selector: 'flow-modal-search',
    templateUrl: './modal-search.component.html',
    styleUrls: ['./modal-search.component.scss']
})
export class ModalSearchComponent implements OnInit {

    @ViewChild('viewdb') viewdb: ViewComponent
    subscriptions: Array<Subscription> = []
    modalConfig: ModalConfig = { opened: false }
    modalOpened: boolean = false

    constructor(
        private modalService: ModalService,
        public appService: AppService
    ) { }

    ngOnInit() {
        this.subscriptions.push(
            this.modalService.modalConfig.subscribe(config => {
                if (config.modal == 2) {
                    //this.viewdb.getData()
                    if (this.viewdb) {
                        this.viewdb.getView()
                    }
                    this.modalConfig = config
                    this.modalOpened = config.opened
                }
            })
        )
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        isDebugMode ? console.log(`ngOnDestroy()`) : undefined
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe()
        })
    }

    eventSelect(event) {
        isDebugMode ? console.log(`eventSelect()`) : undefined
        this.appService.eventSelect.emit(event)
        if (this.modalService.form) {
            this.modalService.form.patchValue(event)
        }
        //
        //console.log(this.modalService.form)
        this.btnClose()
    }

    btnClose() {
        isDebugMode ? console.log(`close()`) : undefined
        this.appService.viewid = undefined
        this.modalService.modalConfig.emit({ modal: 2, opened: false })
    }

    btnClick() {
        isDebugMode ? console.log(`eventSelect()`) : undefined
    }


}
